<template>
  <VuePerfectScrollbar class="requests-list">
    <div v-for="(requests, day, index) in groupedRequests"
         class="day"
         :key="index">
      <div class="day-header">
        <div class="day-name">
          {{ day | relativeTimeInDays(2) | capitalize }}
        </div>
      </div>

      <ul class="days-list">
        <manage-requests-item v-for="(request, index) in requests"
                              :request="request"
                              :key="index"/>
      </ul>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import ManageRequestsItem from '@/components/Common/ManageRequests/ManageRequestsItem'

  export default {
    components: {
      VuePerfectScrollbar,
      ManageRequestsItem
    },

    props: {
      requests: {
        type: Array,
        required: true
      }
    },

    computed: {
      groupedRequests() {
        return _.groupBy(
          this.reversedRequests,
          // transform the date string to milliseconds of the beginning of the day
          // "2021-02-01T00:01:00.000Z" => 1611964800000 (milliseconds)
          request => +new Date(request.last_update).setHours(0,0,0,0)
        )
      },

      reversedRequests() {
        // requests list is coming not sorted from server
        return _.cloneDeep(this.requests).sort((a, b) => {
          return new Date(b.last_update) - new Date(a.last_update)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .requests-list {
    height: 100%;
    position: relative;

    .day-header {
      display: flex;
      justify-content: center;
      margin: 25px 0 15px 0;
    }

    .day-name {
      opacity: .3;
      color: #fff;
      background: #6a6a6a;
      font-size: 16px;
      border-radius: 14px;
      padding: 5px 16px 5px 16px;
    }

    .days-list {
      list-style: none;
      padding: 0;
      margin: 0;
    }
  }
</style>